import { QueryClient } from "@tanstack/react-query";
import getServerConnection from "./consumer";
import { toast } from "@/components/ui/Toast/use-toast";
import { LiveNotificationArgs, MethodStringLiterals } from "./types";
import { SUBMISSION_LOCK_STORAGE_KEY } from "@/lib/constants";

export type ChannelMethods = MethodStringLiterals<ChannelListener>;

export type Message = {
  type: ChannelMethods;
};
class ChannelListener {
  queryClient: QueryClient;
  constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;

    this.received = this.received.bind(this);
  }

  received(data: Message) {
    const { type: methodName, ...otherData } = data;

    if (typeof this[methodName] === "function") {
      (this[methodName] as (data: unknown) => void)(otherData);
    }
  }

  social_profile_connected() {
    this.queryClient.invalidateQueries({ queryKey: ["show-current-user"], exact: false });
  }

  notification() {
    this.queryClient.invalidateQueries({ queryKey: ["user_notifications"] });
  }

  additional_wallet_created() {
    this.queryClient.invalidateQueries({ queryKey: ["additional-wallets"] });
  }

  additional_wallet_deleted() {
    this.queryClient.invalidateQueries({ queryKey: ["additional-wallets"] });
  }

  live_notification({ notification_severity, message }: LiveNotificationArgs) {
    const variant =
      notification_severity === "error" ? "destructive" : notification_severity === "warning" ? "warning" : "default";
    toast({
      title: message,
      variant,
    });
  }

  review_lock_expired({ submission_id }: { submission_id: number }) {
    console.log("review_lock_expired", submission_id);

    localStorage.removeItem(SUBMISSION_LOCK_STORAGE_KEY + "_" + submission_id);
    if (window.location.pathname.includes(`/reviews/${submission_id}`)) {
      toast({
        title: "Review lock expired",
        variant: "destructive",
      });
      setTimeout(() => {
        window.history.replaceState({}, "", "/reviews");
        window.location.reload();
      }, 1000);
    }
  }
}

const connectToUserChannel = (id: number, token: string | undefined, queryClient: QueryClient) => {
  const server = getServerConnection();
  const channelParams = { channel: "UserChannel", id, room: `user_${id}`, token };
  const manager = new ChannelListener(queryClient);

  return server.subscriptions.create(channelParams, manager);
};

export default connectToUserChannel;
